import styled, { keyframes } from "styled-components"

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const CircleLoader = styled.span`
  display: inline-block;
  width: var(--size-6);
  height: var(--size-6);

  border: 2px var(--color-neutral-50) solid;
  border-bottom-color: var(--color-primary);
  border-radius: 9999px;

  animation: ${rotate} 0.8s linear infinite;
`
export default CircleLoader
